module.exports = "https://qp-assets.quero.com/assets/images/onboarding/support.svg?b6f5bd1415e267a457e64a9525fcb47d";